import React from "react";
import { AboutSec } from "./about";

export const About = () => {
  return (
    <React.Fragment>
      <div className="banner-main">
        <AboutSec />
      </div>
    </React.Fragment>
  );
};
